import { Flashcard } from "./components/Flashcard";
import { HintDialog } from "./components/HintDialog";
import { usePracticeSession } from "./hooks/usePracticeSession";
import { pl } from "./i18n/pl";
import styles from "./App.module.css";

export function App() {
  const session = usePracticeSession();

  return (
    <main className={styles.appShell}>
      <Flashcard
        answer={session.answer}
        feedback={session.feedback}
        inputRef={session.inputRef}
        problem={session.problem}
        onAnswerChange={session.setAnswer}
        onSubmit={session.submitAnswer}
      />

      <HintDialog
        open={session.hintOpen}
        problem={session.problem}
        result={session.result}
        onOpenChange={session.setHintOpen}
        onRetry={session.retryCurrentProblem}
      />

      {session.serviceWorker.updateAvailable && (
        <div className={styles.updateBanner} role="status">
          <span>{pl.update.message}</span>
          <button type="button" onClick={session.serviceWorker.applyUpdate}>
            {pl.update.action}
          </button>
        </div>
      )}
    </main>
  );
}
